export default __webpack_public_path__ + "static/media/Quiken_Preparacion_Empaquetado-11.512f8570.svg";